module.exports = __webpack_public_path__ + "static/media/allen.fd2eec3b.png";